import React, { useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { LanguageContext } from "../../useContext/LanguageContext";
import enTranslations from "../../assets/language/en.json";
import frTranslations from "../../assets/language/hn.json";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation } from "react-router-dom";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  const location = useLocation();

  useEffect(() => {
    const section = document.getElementById(location.hash.replace("#", ""));

    if (section) {
        section.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const { language } = useContext(LanguageContext);

  const translations = language === "en" ? enTranslations : frTranslations;

  return (
    <>
      <div>
        <Helmet>
          <title>IMPC: Revitalizing Temples & Advancing SDGs in India</title>

          {/* Google Analytics Script */}
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-XX4VBTPB63"
          ></script>
          <script>
            {` 
          window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            }
            gtag('js', new Date());

           gtag("config", "G-XX4VBTPB63");
        `}
          </script>
          <meta
            name="description"
            content="IMPC rejuvenates Indian temples and cultural sites, advancing UN SDGs through poverty eradication, education, gender equality, and environmental sustainability."
          />
          <meta
            name="keywords"
            content="Indian temple restoration projects,Heritage restoration in India,Heritage site development programs,Protecting ancient temples and cultural sites,Funding heritage site restoration, Indian temples and cultural site restoration projects, Temple restoration volunteer programs, Volunteer for cultural site preservation in India,  Empowering women in heritage restoration, Jobs around Indian temples, Waste management solutions in cultural sites"
          />

          <meta
            property="og:title"
            content="IMPC: Revitalizing Temples & Advancing SDGs in India"
          />
          <meta
            property="og:description"
            content="IMPC rejuvenates Indian temples and cultural sites, advancing UN SDGs through poverty eradication, education, gender equality, and environmental sustainability."
          />
          <meta
            property="og:image"
            content="https://bhagvabucket.s3.amazonaws.com/logo.png"
          />
          <meta property="og:url" content="https://www.impc.co.in/about-us" />
          <meta property="og:type" content="website" />

          <link rel="canonical" href="https://www.impc.co.in/about-us" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Helmet>

        {/* banner section start */}
        <section
          class="bsb-hero-1 px-3 banner-gradient about-us-main-banner"
          // style={{
          //   backgroundImage: `url(${banner})`,
          //   backgroundSize: "cover",
          //   backgroundPosition: "50%, 50%",
          //   backgroundRepeat: "no-repeat",
          //   display: "flex",
          //   alignItems: "flex-end",
          //   minHeight: "100vh",
          // }}
        >
          <div className="container">
            <div className="row justify-content-md-center align-items-end">
              <div className="col-12 col-md-11 col-lg-9 col-xl-8 col-xxl-7 text-center">
                <h1
                  className="display-5 text-white fw-bold mb-2"
                  data-aos="fade-up"
                >
                  {translations.aboutUsbannerTittle}
                </h1>
                <p className="lead text-white mb-4" data-aos="fade-up">
                  {translations.aboutUsbannerDescription}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          className="container-fluid About-us-inner-banner py-5"
          data-aos="fade-down"
        >
          <div className="container">
            {/* <h3>{translations.aboutUsMissionStatementTittle}</h3> */}
            <p>{translations.aboutMissionStatementDescription_1}</p>
            <p>{translations.aboutMissionStatementDescription_2}</p>
            <h2 id="mahasangam-yatra" className="fw-bold about-us-yatra-title">Mahasangam Yatra: A Divine Journey of Heritage and Unity</h2>
            <p>The Mahasangam Yatra commenced with a powerful spiritual aura as 108 Trishuls made of Ashtadhatu were consecrated through a grand Trishul Abhisheka in Prayagraj. The Yatra began with a magnificent procession, symbolizing the essence of Sanatan Dharma and the unity of Bharatvarsha.</p>
            <p>Carrying 12 Trishuls, the Yatra traversed the sacred path covering the 12 Jyotirlingas, the 4 Dhams, and 12 Shakti Peethas, weaving together the diverse spiritual threads of India. This profound journey was not just a pilgrimage but a powerful movement to raise awareness about temple restoration and upliftment, fostering a sense of duty among devotees towards preserving the sanctity of these heritage sites.</p>
            <h5>Empowering Bharatvarsha: Key Highlights of the Yatra
            </h5>    
            <ul>
              <li><span className="fw-bold">Community Unity:</span>
                 Strengthened regional bonds, fostering harmony and temple restoration.
              </li>
              <li><span className="fw-bold">Youth Engagement:</span>
               Inspired young minds to reconnect with cultural and spiritual heritage.
              </li>
              <li><span className="fw-bold">Modernizing Tradition:</span>
              Promoted digitalization of temple activities and heritage preservation through technology.
              </li>
            </ul>
            <h5>Path of the Yatra – Sacred Destinations Visited
            </h5>
            <div className="my-3">
              <p className="m-0">📍 January 25: Prayagraj → Varanasi</p>
              <p className="m-0">📍 January 26: Varanasi → Deoghar</p>
              <p className="m-0">📍 January 27: Deoghar → Tarkeshwar</p>
              <p className="m-0">📍 January 28: Tarkeshwar → Puri</p>
              <p className="m-0">📍 January 29: Puri → Samarlakota</p>
              <p className="m-0">📍 January 30: Samarlakota → Draksharamam → Palakollu</p>
              <p className="m-0">📍 January 31: Palakollu → Bhimavaram → Amravati</p>
              <p className="m-0">📍 February 1: Amravati → Srisailam</p>
              <p className="m-0">📍 February 2: Srisailam → Vellore</p>
              <p className="m-0">📍 February 3: Vellore → Madurai</p>
              <p className="m-0">📍 February 4: Madurai → Rameswaram</p>
              <p className="m-0">📍 February 5: Rameswaram → Coimbatore</p>
              <p className="m-0">📍 February 6: Coimbatore</p>
              <p className="m-0">📍 February 7: Coimbatore → Kolhapur</p>
              <p className="m-0">📍 February 8: Kolhapur → Bhimashankar</p>
              <p className="m-0">📍 February 9: Bhimashankar → Aurangabad</p>
              <p className="m-0">📍 February 10: Aurangabad → Nashik</p>
              <p className="m-0">📍 February 11: Nashik → Vadodara</p>
              <p className="m-0">📍 February 12: Vadodara → Somnath</p>
              <p className="m-0">📍 February 13: Somnath → Dwarka</p>
              <p className="m-0">📍 February 14: Dwarka → Ahmedabad</p>
              <p className="m-0">📍 February 15: Ahmedabad → Dahod</p>
              <p className="m-0">📍 February 16: Dahod → Ujjain</p>
              <p className="m-0">📍 February 17: Ujjain → Omkareshwar</p>
              <p className="m-0">📍 February 18: Omkareshwar → Nalkheda</p>
              <p className="m-0">📍 February 19: Nalkheda → Datia → Rishikesh</p>
              <p className="m-0">📍 February 20: Datia → Bharatpur → Mathura</p>
              <p className="m-0">📍 February 21: Mathura → Agra</p>
              <p className="m-0">📍 February 22: Agra → Prayagraj</p>
            </div>
            <h5>A Legacy of Devotion and Restoration
            </h5>
            <p>By weaving together rivers, temples, and sacred cities, the Mahasangam Yatra became a testament to India’s living spiritual legacy. It ignited a spirit of unity, devotion, and proactive participation, ensuring that the cultural and religious heritage of Bharatvarsha is preserved for generations to come.</p>

            <h2 id="mahasangam-trishool-pujan" className="fw-bold about-us-yatra-title">Mahasangam Trishool Pujan: A Sacred Confluence of Devotion and Dharma</h2>
            <p>
            The Mahasangam Trishool Pujan was not just a ritual—it was a grand spiritual awakening that began in the sacred waters of Prayagraj Kumbh. Over 21 divine days, 108 Trishuls, crafted from the essence of Sanatan Dharma, were consecrated with elaborate Vedic rituals, absorbing the spiritual vibrations of the Triveni Sangam—the sacred confluence of Ganga, Yamuna, and Saraswati.
            </p>
            <p>
            As the Mahasangam Yatra embarked on its divine course, these Trishuls became carriers of faith, traveling through the holiest sites of Bharat—12 Jyotirlingas, 4 Dhams, and 12 Shakti Peethas. Each day, at every revered stop, they were bathed in sacred waters from the Kumbh Sangam and worshipped by learned Vedic Pandits, keeping the fire of devotion alive.
            </p>
            <p>This yatra was not just a journey—it was a movement of spiritual resurgence, rekindling the lost essence of Dharma, devotion, and temple restoration. Each Trishul, infused with divine energy, stood as a beacon, uniting millions in the eternal spirit of Sanatan Dharma.</p>


            <h2 id="bhagva-trishool-yatra" className="fw-bold about-us-yatra-title">Bhagva Trishool Yatra: A Journey of Dharma and Unity</h2>
            <p>Following the successful completion of the Mahasangam Yatra, the Bhagva Trishool Yatra embarked on a sacred mission to weave the threads of Dharma across India. This Yatra covered major states including Uttar Pradesh, Haryana, Rajasthan, Punjab, Delhi, and Madhya Pradesh, creating a powerful spiritual resonance across the land.
            </p>
            <p>
            The Yatra's path was marked by visits to small cities and towns, where it connected with local communities to ignite a sense of devotion and awareness about Sanatan Dharma. Through discourses, devotional activities, and community gatherings, the Yatra aimed to empower individuals with the essence of India’s spiritual heritage.
            </p>
            <h5>Empowering Bharatvarsha: Key Highlights of the Yatra
            </h5>    
            <ul>
              <li><span className="fw-bold">Reaching the Heart of Bharat:</span>
                <ul>
                  <li>Connected with local communities in small towns and cities, emphasizing the significance of Dharma in daily life.</li>
                  <li>Strengthened grassroots participation in preserving cultural and spiritual values.</li>
                </ul>
              </li>
              <li><span className="fw-bold">Spreading Awareness for Dharma:</span>
                <ul>
                  <li>Organized spiritual discourses and kirtans to enlighten people about Sanatan traditions.</li>
                  <li>Emphasized the importance of temple restoration and collective spiritual responsibilities.</li>
                </ul>
              </li>

              <li><span className="fw-bold">Unity through Diversity:</span>
                <ul>
                  <li>Encouraged inter-community harmony by celebrating regional traditions and festivals.</li>
                  <li>Promoted a unified vision for the upliftment of Bharatvarsha's spiritual heritage.</li>
                </ul>
              </li>
            </ul>
            <h5>Bhagva Trishool Yatra Route</h5>
            <ul>
              <li>
              <span className="fw-bold">Uttar Pradesh</span>: Prayagraj → Ayodhya → Lucknow → Sitapur → Shahjahanpur → Bareilly → Badaun → Sambhal → Chandausi → Meerut → Haridwar
              </li>
              <li>
              <span className="fw-bold">Haryana</span>: Yamunanagar → Kurukshetra → Ambala → Chandigarh → Patiala → Kaithal → Panipat → Jind → Hisar (Sisai) → Rohtak → Pataudi → Bhiwadi
              </li>
              <li>
              <span className="fw-bold">Rajasthan</span>: Nalhar Mahadev → Bharatpur
              </li>
              <li>
              <span className="fw-bold">Madhya Pradesh</span>: Morena → Agra
              </li>
              <li>
              <span className="fw-bold">Uttar Pradesh</span>: Mathura → Vrindavan → Delhi (Mahipalpur)
              </li>
              <li>
              <span className="fw-bold">Delhi</span>: Talkatora Stadium (Press Conference & Maha Abhishek)
              </li>
              <li>
              <span className="fw-bold">Final Maha Abhishek</span>: Prachin Shiv Mandir, Mahipalpur (11 Days)
              </li>
            </ul>

            <p>By bridging spiritual wisdom with grassroots action, the Bhagva Trishool Yatra became a beacon of unity, faith, and cultural pride, inspiring communities to uphold the essence of Sanatan Dharma.</p>
            
             
            <h2 id="shiv-shakti-kendra" className="fw-bold about-us-yatra-title">Shiv-Shakti Kendra: A Divine Initiative for Temple Upliftment</h2>

            <p>
            Shiv-Shakti Kendra is a sacred initiative dedicated to enriching India's revered temples with spiritual energy and modern facilities. We invite your temple to receive and install one of the divine Trishools consecrated in the Mahasangam Trishool Pujan. </p>
            <p>To be a part of this sacred mission, we encourage 51 devotees from your temple and city to join this divine journey and establish the Trishool in your temple with grandeur.</p>
            <h5>Services Provided by IMPC to Temples:</h5>
            <ul>
              <li>
              <span className="fw-bold">WiFi Connectivity </span>– Enhancing the temple’s digital reach.
              </li>
              <li>
              <span className="fw-bold">Sound System for Devotional Events </span> – Speakers and microphones for an enriched spiritual experience.
              </li>
              <li>
              <span className="fw-bold">Support for Temple Restoration & Development </span>– Assistance as needed for structural and religious upliftment.
              </li>
              <li>
              <span className="fw-bold">Projector Facility</span> – For spreading religious teachings, scriptures, and spiritual knowledge.
              </li>
              <li>
              <span className="fw-bold">Social Media & Website Promotion</span> – Strengthening the temple’s online presence through digital outreach.
              </li>
            </ul>
            <p>
            This is a once-in-a-lifetime opportunity to be part of a grand spiritual movement and empower your temple with divine energy and modern advancements.
            </p>
            <p>
            We invite you to join this sacred mission, spreading the light of Sanatan Dharma far and wide.
            </p>

            <p className="fw-bold">{translations.aboutImpcCommitteesListText}:</p>

            <div className="about-us-content">
              <h4>{translations.aboutImpcCommittesSectionHeadding_1}</h4>
              <p>{translations.aboutImpcCommittesSectionDescription_1}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_2} </h4>
              <p>{translations.aboutImpcCommittesSectionDescription_2}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_3} </h4>
              <p>{translations.aboutImpcCommittesSectionDescription_3}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_4}</h4>
              <p>{translations.aboutImpcCommittesSectionDescription_4}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_5}</h4>
              <p>{translations.aboutImpcCommittesSectionDescription_5}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_6} </h4>
              <p>{translations.aboutImpcCommittesSectionDescription_6}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_7}</h4>
              <p>{translations.aboutImpcCommittesSectionDescription_7}</p>
              <h4>{translations.aboutImpcCommittesSectionHeadding_8}</h4>
              <p>{translations.aboutImpcCommittesSectionDescription_8}</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
